import { Action } from '@ngrx/store';

export class UserAcceptCampaignActions implements Action {

    public static getUserAcceptCampaign: string = '[User Accept Campaign] get_user_accept_campaign';
    public static getUserAcceptCampaignError: string = '[User Accept Campaign] get_user_accept_campaign_error';
    public static getUserAcceptCampaignSuccess: string = '[User Accept Campaign] get_user_accept_campaign_success';

    public static putUserAcceptCampaign: string = '[User Accept Campaign] put_user_accept_campaign';
    public static putUserAcceptCampaignError: string = '[User Accept Campaign] put_user_accept_campaign_error';
    public static putUserAcceptCampaignSuccess: string = '[User Accept Campaign] put_user_accept_campaign_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
